import styles from './LoadingOverlay.module.css'

export default function LoadingOverlay({ isLoading, message = "Updating..." }) {
    if (!isLoading) return null

    return (
        <div className={styles.overlay}>
            <div className={styles.content}>
                <div className={styles.logoContainer}>
                    <img
                        src="/logo.png"
                        alt="Kadle Logo"
                        className={styles.logo}
                    />
                    <div className={styles.spinner}></div>
                </div>
                <p className={styles.message}>{message}</p>
            </div>
        </div>
    )
}